import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "components/Header";
import Footer from "components/Footer";
import Sitemap from "pages/sitemap/Sitemap";
import "styles/scss/layout.scss"; // CSS 스타일 추가

const Layout = () => {
    const location = useLocation(); // 현재 페이지 경로 가져오기
    const isHome = location.pathname === "/" || location.pathname === "/draft02"; // 홈 페이지 확인
    const isLoginPage = location.pathname === "/login"; // 로그인 페이지 확인

    return (
        <div className="layout">
            {/* 로그인 페이지가 아닐 때만 Header 표시 */}
            {!isLoginPage && <Header />} 

            <main className="main-content">
                <Outlet />
            </main>

            {/* 홈 페이지와 로그인 페이지가 아닐 때만 Footer 표시 */}
            {!isHome && !isLoginPage && <Footer />} 

            <Sitemap />
        </div>
    );
};

export default Layout;
